<template>
    <div class="cargar-cotizacion">
        <v-file-input
            chips
            accept=".xlsx, .xls"
            label="Cargar Cotización Excel"
            @change="onFileChange"
        ></v-file-input>
        <v-btn
        color="blue-grey"
        class="ma-2 white--text"
        @click="handleFileUpload"
         title="Procesar Archivo"
         :disabled="!file"
        >
        Subir
        <v-icon right dark>
            mdi-cloud-upload
        </v-icon>
        </v-btn>
        <v-btn
        color="blue-grey"
        class="ma-2 white--text"
        title="Descargar Formato"
        @click="downloadCv"
        >
        <v-icon dark>
            mdi mdi-file-download
        </v-icon>
        </v-btn>
    </div>
</template>
<script>
import { procesarXLS } from './procesarxls';
import { exportToExcel } from './excelExport';
export default {
    name: "CargarCotizacion",
    data() {
        return {
            file: null,
            error: null,
            success: false,
            productos: [
                { codigo: "P001", producto: 'Producto A',cantidad: 2, precio: 15, subtotal:30, descuento:0 },
                { codigo: "P002", producto: 'Producto B',cantidad: 20, precio: 19, subtotal:380, descuento:0 },
            ]
        };
    },
    methods: {
       async onFileChange(file) {
            const selectedFile = file 
            if (selectedFile && (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || selectedFile.type === "application/vnd.ms-excel")) {
                this.file = selectedFile;
                this.error = null;
                const { procesarArchivo } = new procesarXLS();
            procesarArchivo(this.file);
            }
        },

        handleFileUpload() {
            
            const { procesarArchivo } = new procesarXLS();
            procesarArchivo(this.file);
            const productoscotizacion = this.$store.getters.getItemsCotizacion
            this.$emit("setproductos", productoscotizacion);
            this.$store.dispatch("setItemsCotizacion",[]);
            this.file=null;
        },

        downloadCv() {
            exportToExcel(this.productos, 'formato_cargamasiva', 'Productos');
        }
    },
};
</script>

<style scoped>
.cargar-cotizacion {
    margin: 0 auto;
    text-align: center;
    display: flex; 
}

</style>